const registerOfflineServiceWorker = () => {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  // Register the shell cache in production. Keeping it disabled by default in
  // CRA development prevents stale localhost bundles from masking code fixes.
  const allowInDevelopment = String(process.env.REACT_APP_ENABLE_OFFLINE_SW_DEV || '').toLowerCase() === 'true';
  if (process.env.NODE_ENV !== 'production' && !allowInDevelopment) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/offline-sw.js').catch((error) => {
      console.warn('Offline application shell could not be registered:', error);
    });
  });
};

export default registerOfflineServiceWorker;
